import { createSlice } from "@reduxjs/toolkit";
import { getAxios, postAxios, getIntSvcAxios, postIntSvcAxios, postRRAxios } from "./axiosActions";
import { fetchGPTUsageData } from "./logs";
import _ from 'lodash';
import toast from "../../common/toastNotistack";
import { fetchReviews } from "./reviews";
import { getMasterDataUpdateSuccess } from "./location";
export const initialState = {
  loading: false,
  processLoading: false,
  responseData: [],
  pipelinesData: {},
  error: false,
  processPrompts: { Segments: {}, Summarize: {}, TopicGeneration: {} },
  issueList: [],
  suggestionList: [],
  addIssue: '',
  deleteIssue: ''
};
const pipelinesSlices = createSlice({
  name: "pipelines",
  initialState,
  reducers: {
    getPipelines: (state) => {
      state.processLoading = true;
    },
    getPipelinesSuccess: (state, { payload }) => {
      let response = _.cloneDeep(state.responseData);
      response[payload.processId] = payload?.response?.responseContent
      state.responseData = response;
      // state.responseData = payload?.responseContent;
      state.processLoading = false;
      state.error = false;
    },
    getPipelinesDataSuccess: (state, { payload }) => {
      state.pipelinesData = payload;
      state.processLoading = false;
      state.error = false;
    },
    getPipelinesFailure: (state) => {
      state.processLoading = false;
      state.error = true;
    },
    getProcessPrompts: state => {
      state.loading = true;
    },
    getProcessPromptsSegmentsSuccess: (state,
      { payload }) => {

      state.processPrompts[payload.step] = payload.response;
      state.loading = false;
    },

    getProcessPromptsFailure: (state) => {
      state.loading = false;
      state.error = true;
    },
    getIssueList: state => {
      state.loading = true;
    },
    getIssueListSuccess: (state,
      { payload }) => {

      state.issueList = payload;
      state.loading = false;
    },

    getIssueListFailure: (state) => {
      state.loading = false;
      state.error = true;
    },
    getSuggestionList: state => {
      state.loading = true;
    },
    getSuggestionListSuccess: (state,
      { payload }) => {

      state.suggestionList = payload;
      state.loading = false;
    },

    getSuggestionListFailure: (state) => {
      state.loading = false;
      state.error = true;
    },
    addIssue: state => {
      state.loading = true;
    },
    addIssueSuccess: (state,
      { payload }) => {

      state.addIssue = payload;
      state.loading = false;
    },

    addIssueFailure: (state) => {
      state.loading = false;
      state.error = true;
    },
    deleteIssuesuccess: (state, { payload }) => {
      state.deleteIssue = payload;
      state.loading = false
    },
    updateIssueSuccess: (state, { payload }) => {
      state.updateIssue = payload
    },
    createIssue: state => {
      state.isCreateIssue = true;
      state.errorCreateIssue = false;
    },
    createIssueSuccess: state => {
      state.isCreateIssue = false;
      state.errorCreateIssue = false;
    },
    createIssueFailure: state => {
      state.isCreateIssue = false;
      state.errorCreateIssue = true;
    },
    createIssueList: state => {
      state.isCreateIssue = true;
      state.errorCreateIssue = false;
    },
    createIssueSuccessList: state => {
      state.isCreateIssue = false;
      state.errorCreateIssue = false;
    },
    createIssueFailureList: state => {
      state.isCreateIssue = false;
      state.errorCreateIssue = true;
    },
  },
});

export const {
  getPipelines,
  getPipelinesSuccess,
  getPipelinesDataSuccess,
  getPipelinesFailure,
  getProcessPrompts, getProcessPromptsFailure, getProcessPromptsSegmentsSuccess, getIssueList, getIssueListFailure, getIssueListSuccess,
  getSuggestionList, getSuggestionListFailure, getSuggestionListSuccess,
  addIssue, addIssueFailure, addIssueSuccess, deleteIssuesuccess, updateIssueSuccess, createIssueSuccess, createIssueFailure, createIssue,createIssueSuccessList, createIssueFailureList, createIssueList

} = pipelinesSlices.actions;
export const pipelinesSelector = (state) => state.pipelines;
export default pipelinesSlices.reducer;
export const fetchPipelines = (processId, companyId, userId, data, paramObj, isSaveSteps, count, isOverwriteTopics, requestId, startDate, endDate) => {
  return async (dispatch) => {
    dispatch(getPipelines())
    try {
      const params = { processId: processId, companyId: companyId, data: data, params: paramObj, isSaveSteps, isOverwriteTopics, count };
      const response = await postAxios(
        "api/Processes/Execute",
        { params: params }
      );
      dispatch(getPipelinesSuccess({ response, processId }))
      if (isOverwriteTopics) {
         dispatch(fetchReviews(startDate, endDate, companyId))
      }
      if (userId) {
        // dispatch(fetchGPTUsageData(companyId, userId))
      }
    } catch (error) {
      console.log(error);
      dispatch(getPipelinesFailure())
    }
  };
};
export const fetchPipelinesUsingAkka = (processId, companyId, userId, data, paramObj, isSaveSteps, count, isOverwriteTopics, requestId, startDate, endDate) => {
  return async (dispatch) => {
    dispatch(getPipelines())
    try {
      const params = { processId: processId, companyId: companyId, data: data, params: paramObj, isSaveSteps, isOverwriteTopics, count, requestId };
      const response = await postIntSvcAxios(
        "Integrations/Pipelines/Execute",
        { params: params }
      );
      dispatch(getPipelinesSuccess({ response, processId }))
      if (userId) {
        if (isOverwriteTopics) {
          dispatch(fetchReviews(startDate, endDate, companyId))
        }
        // dispatch(fetchGPTUsageData(companyId, userId))
      }
    } catch (error) {
      console.log(error);
      dispatch(getPipelinesFailure())
    }
  };
};
export const getPipelinesData = (requestId) => {
  return async (dispatch) => {
    dispatch(getPipelines())
    try {
      //const params = { processId: processId, companyId: companyId, data: data, params: paramObj, isSaveSteps, isOverwriteTopics,  count };
      const response = await getIntSvcAxios(
        "Integrations/Pipelines/GetPipelinesData?RequestId=" + requestId,
        { params: {} }
      );
      dispatch(getPipelinesDataSuccess(response))
      // if (userId) {
      //   dispatch(fetchGPTUsageData(companyId, userId))
      // }
    } catch (error) {
      console.log(error);
      dispatch(getPipelinesFailure())
    }
  };

};

export const fetchProcessPrompts = (companyId, process, step) => {

  return async (dispatch) => {
    dispatch(getProcessPrompts())
    try {
      //const params = { processId: processId, companyId: companyId, data: data, params: paramObj, isSaveSteps, isOverwriteTopics,  count };
      const response = await getAxios(
        "api/Prompts/GetProcessPrompt?companyId=" + companyId + "&processName=" + process + "&step=" + step,
        { params: {} }
      );


      dispatch(getProcessPromptsSegmentsSuccess({ response: response, step: step }))


      // if (userId) {
      //   dispatch(fetchGPTUsageData(companyId, userId))
      // }
    } catch (error) {
      console.log(error);
      dispatch(getProcessPromptsFailure())
    }
  };

};
export const fetchPipelinePrompt = (promptId, step) => {

  return async (dispatch) => {
    dispatch(getProcessPrompts())
    try {
      //const params = { processId: processId, companyId: companyId, data: data, params: paramObj, isSaveSteps, isOverwriteTopics,  count };
      const response = await getAxios(
        "api/Prompts/GetPrompt?promptId=" + promptId,
        { params: {} }
      );
      dispatch(getProcessPromptsSegmentsSuccess({ response: response?.[0], step: step }))


      // if (userId) {
      //   dispatch(fetchGPTUsageData(companyId, userId))
      // }
    } catch (error) {
      console.log(error);
      dispatch(getProcessPromptsFailure())
    }
  };

};
export const fetchIssueList = (companyId) => {

  return async (dispatch) => {

    dispatch(getIssueList())
    try {
      //const params = { processId: processId, companyId: companyId, data: data, params: paramObj, isSaveSteps, isOverwriteTopics,  count };
      const response = await getAxios(
        "api/Issues/GetIssueList?companyId=" + companyId,
        { params: {} }
      );

      dispatch(getMasterDataUpdateSuccess({key:'issueList',data:response}))
      dispatch(getIssueListSuccess(response))


      // if (userId) {
      //   dispatch(fetchGPTUsageData(companyId, userId))
      // }
    } catch (error) {
      console.log(error);
      dispatch(getIssueListFailure())
    }
  };

};
export const fetchSuggestionList = (issueListId) => {

  return async (dispatch) => {

    dispatch(getSuggestionList())
    try {
      //const params = { processId: processId, companyId: companyId, data: data, params: paramObj, isSaveSteps, isOverwriteTopics,  count };
      const response = await getAxios(
        "api/Issues/GetSuggestionList?issueListId=" + issueListId,
        { params: {} }
      );


      dispatch(getSuggestionListSuccess(response))


      // if (userId) {
      //   dispatch(fetchGPTUsageData(companyId, userId))
      // }
    } catch (error) {
      console.log(error);
      dispatch(getSuggestionListFailure())
    }
  };

};
export const triggerCreateIssue = (data, issueListId) => {

  return async (dispatch) => {

    dispatch(addIssue())
    try {
      //const params = { processId: processId, companyId: companyId, data: data, params: paramObj, isSaveSteps, isOverwriteTopics,  count };
      const response = await postRRAxios(
        "api/Issues/CreateIssue", {
        params: data,
      }
      );


      dispatch(addIssueSuccess(response))
      if (response) {
  
        if (response.statusMessage === 'Already Exist') {
          toast('Issue already exists!', { variant: 'warning' })
        }
        if (response.statusMessage === 'Success') {
          toast('Issue added!', { variant: 'success' })
        }
        if (issueListId) {
          dispatch(fetchSuggestionList(issueListId))
        }

      }
    } catch (error) {
      console.log(error);
      dispatch(addIssueFailure())
      toast('Something went wrong!', { variant: 'error' })
    }
  };

};
export const triggerDeleteIssue = (data, issueListId) => {

  return async (dispatch) => {

    dispatch(addIssue())
    try {
      //const params = { processId: processId, companyId: companyId, data: data, params: paramObj, isSaveSteps, isOverwriteTopics,  count };
      const response = await postAxios(
        "api/Issues/ArchivedIssue?issueId=" + data, {
        params: {},
      }
      );


      dispatch(deleteIssuesuccess(response))
      if (response) {

        if (issueListId) {
          dispatch(fetchSuggestionList(issueListId))
        }

      }
    } catch (error) {
      console.log(error);
      dispatch(addIssueFailure())
      toast('Something went wrong!', { variant: 'error' })
    }
  };

};
export const triggerUpdateIssue = (data, issueListId) => {

  return async (dispatch) => {

    dispatch(addIssue())
    try {
      //const params = { processId: processId, companyId: companyId, data: data, params: paramObj, isSaveSteps, isOverwriteTopics,  count };
      const response = await postAxios(
        "api/Issues/UpdateIssue", {
        params: data,
      }
      );


      dispatch(updateIssueSuccess(response))
      if (response) {
        if (response.statusMessage === 'Success') {
          toast('Issue Updated!', { variant: 'success' })
        }
        if (issueListId) {
          dispatch(fetchSuggestionList(issueListId))
        }

      }
    } catch (error) {
      console.log(error);
      dispatch(addIssueFailure())
      toast('Something went wrong!', { variant: 'error' })
    }
  };

};
export function insertIssueList(data,setIssueName) {
  
  return async dispatch => {
    dispatch(createIssue());
    try {
      const response = await postAxios('api/Issues/CreateIssueList', { params: data });
      if (response) {
        dispatch(createIssueSuccess());
        if(data?.CompanyId){
          dispatch(fetchIssueList(data?.CompanyId))
          setIssueName('')
        }
        toast('Issue List Saved!', { variant: 'success' })
      } else {
        dispatch(createIssueFailure());
      }

    } catch (error) {
      dispatch(createIssueFailure());
    }
  };
}
export function triggerUpdateIssueList(data, isOpenIssues) {
  return async dispatch => {
    dispatch(createIssue());
    try {
      const response = await postAxios('api/Issues/UpdateIssueList', { params: data });
      if (response) {
        dispatch(createIssueSuccess());
        if(data?.companyId){
          dispatch(fetchIssueList(data?.companyId))
        }
        toast('Issue List  Saved!', { variant: 'success' })
      } else {
        dispatch(createIssueFailure());
      }

    } catch (error) {
      dispatch(createIssueFailure());
    }
  };
}
export function insertIssue(data, isOpenIssues) {
  return async dispatch => {
    dispatch(createIssue());
    try {
      const response = await postRRAxios('api/Issues/CreateIssue', { params: data });
      if (response) {
        dispatch(createIssueSuccess());
        toast('Issue Saved!', { variant: 'success' })
      } else {
        dispatch(createIssueFailure());
      }

    } catch (error) {
      dispatch(createIssueFailure());
    }
  };
}
export const deleteIssueList = (issueListId,companyId) => {

  return async (dispatch) => {

    dispatch(createIssue())
    try {
      //const params = { processId: processId, companyId: companyId, data: data, params: paramObj, isSaveSteps, isOverwriteTopics,  count };
      const response = await getAxios(
        "api/Issues/DeleteIssueList?issueListId=" + issueListId,
        { params: {} }
      );


      dispatch(createIssueSuccess(response))
      if(response&&companyId){
        dispatch(fetchIssueList(companyId))
      }


      // if (userId) {
      //   dispatch(fetchGPTUsageData(companyId, userId))
      // }
    } catch (error) {
      console.log(error);
      dispatch(createIssueFailure())
    }
  };

};
